import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import useLanguage from "@/hooks/useLanguage";
import clsx from "clsx";
import { SvgIcon } from "../SvgIcon";
import "./header.scss";
import "./mobile.header.scss";
import { Dropdown, Space, message } from "antd";
import type { MenuProps } from "antd";
import { getUser, logOut } from "@/api/config";
import pubLink from "@/assets/svg/publink.svg";
import { useLocation } from "react-router-dom";
import { IS_MOBILE } from "@/utils/tool";
import { userAtom } from "@/store/user";
import { useRecoilValue } from "recoil";
import useQuit from "@/hooks/useQuit";

const Header = (props: {
  showLogo?: boolean;
  title?: string;
  step?: number;
  isHideUser?: boolean;
  setStep?: (step: number) => void;
}) => {
  const { isHideUser, showLogo = true } = props;
  const { language, setLanguage } = useLanguage();
  const { quit } = useQuit();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const user = useRecoilValue(userAtom);
  const items: MenuProps["items"] = [
    !IS_MOBILE && {
      key: "personal",
      label: t("个人中心"),
    },
    IS_MOBILE && {
      key: "user",
      label: user.phone,
    },
    IS_MOBILE && {
      type: "divider",
    },
    {
      key: "quit",
      label: t("退出登录"),
    },
  ];

  /**
   * 切换语言
   */
  const onLanguage = (newValue?: "zh" | "en") => {
    let value = newValue;
    if (!value) {
      value = language === "en" ? "zh" : "en";
    }
    setLanguage(value);
  };

  const storageChange = (storageEvent: StorageEvent) => {
    if (storageEvent.key === "language") {
      setLanguage(storageEvent.newValue as "en" | "zh");
    }
  };

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case "quit":
        quit();
        break;
      case "personal":
        const user = getUser();
        if (user?.temporary) {
          messageApi.error(t("为了您的账号安全，请验证登录"), () => {
            quit("/personal/order");
          });
          return;
        }
        navigate("/personal");
        break;
      default:
        break;
    }
  };

  /**
   * 去登录
   */
  const toLogin = () => {
    if (IS_MOBILE && props.step === 1) {
      window.localStorage.setItem("step", "1");
    }
    window.location.href = `/login?goto=${encodeURIComponent(
      `${location.pathname}${location.search}`
    )}`;
  };
  //   useEffect(() => {
  //     window.addEventListener("storage", storageChange);
  //     return () => {
  //       window.removeEventListener("storage", storageChange);
  //     };
  //   }, []);
  return (
    <div className={clsx("pay-head", IS_MOBILE && "isMobile mobile-pay-head")}>
      {contextHolder}
      {showLogo && (props.step === 0 || !props.step) && (
        <span className="head-logo">
          <img src={pubLink} alt="" />
        </span>
      )}
      {props.step === 1 && (
        <span
          className="back"
          onClick={() => {
            props.setStep(0);
            window.localStorage.removeItem("step");
          }}
        >
          <SvgIcon
            className="back-icon"
            icon="icon-a-xianxingxiangzuo"
            width="16"
            height="16"
          />
          <span>{t("返回")}</span>
        </span>
      )}

      {props.title && (
        <div
          className="title-wrapper"
          style={IS_MOBILE ? { margin: "auto" } : {}}
        >
          {!IS_MOBILE && <span className="divider"></span>}
          <span className="title">{props.title}</span>
        </div>
      )}
      <div
        className="right"
        // style={IS_MOBILE && user.phone ? { marginLeft: 0 } : {}}
      >
        {/* <i className="icon-yingwen"></i> */}
        <span
          className="language"
          //   style={IS_MOBILE ? (user.phone ? {} : { paddingRight: 0 }) : {}}
          onClick={() => onLanguage()}
        >
          <SvgIcon
            width="20"
            height="20"
            icon={language === "zh" ? "icon-yingwen" : "icon-zhongwen"}
            attributes={{ fill: "var(--kx-fill-6)" }}
          />
        </span>

        {!isHideUser && (
          <>
            <span
              className="divider"
              style={IS_MOBILE ? { margin: 0 } : {}}
            ></span>
            <span className="login-text" id="header_right">
              {user.phone ? (
                <>
                  <Dropdown
                    menu={{
                      items: items,
                      onClick: handleMenuClick,
                    }}
                    getPopupContainer={() =>
                      document.getElementById("header_right")
                    }
                  >
                    {IS_MOBILE ? (
                      <span>
                        <SvgIcon
                          width="20"
                          height="20"
                          icon={"icon-personal"}
                          attributes={{ fill: "var(--kx-fill-5)" }}
                        />
                      </span>
                    ) : (
                      <span>
                        <Space style={{ color: "var(--kx-text-2)" }}>
                          {user.phone || t("个人中心")}
                        </Space>
                        <SvgIcon
                          width="16"
                          height="16"
                          icon={"icon-a-xianxingxiangxia"}
                          attributes={{ fill: "var(--kx-fill-5)" }}
                        />
                      </span>
                    )}
                  </Dropdown>
                </>
              ) : (
                <span onClick={toLogin}>{t("登录")}</span>
              )}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
